<template>
  <v-container>
    <ScoreboardStudent />
  </v-container>
</template>

<script>
import ScoreboardStudent from '../../components/Festival/Student/ScoreboardStudent.vue'
export default {
	components:{
		ScoreboardStudent,
	}
};
</script>